import CotplayHubScreen from './CotplayHubScreen';

export default CotplayHubScreen;
